import { apiRequest } from "../index";

export const getAllreviews = async ({page , limit , type , search , filter }) => {
  return apiRequest(`/api/owner/reviews?type=${type}&page=${page}&limit=${limit}&search=${search}&filter=${filter}`, "GET");
};

export const getReviewById = async (reviewId) => {
  return apiRequest(`/api/owner/reviews/${reviewId}`, "GET");
};